import React from 'react';

import { ListCollapse } from '../ListCollapse/ListCollapse';
import { Search } from '../Search/Search';
import { ListItemIcon } from 'shared/components';
import {
  IconButton,
  Menu,
  MenuItem,
  CircularProgress
} from 'e100-react-components';
import { EmptyItemsMessage } from './EmptyItemsMessage/EmptyItemsMessage';
import { EmptyFilteredItemsMessage } from './EmptyFilteredItemsMessage/EmptyFilteredItemsMessage';
import { StationAutoselectOption } from 'entities/stations';
import { FavouriteStationsDeleteModal } from '../../FavouriteStationsDeleteModal/FavouriteStationsDeleteModal';
import { FavouriteStationsAddSnackbar } from '../../FavouriteStationsAddSnackbar/FavouriteStationsAddSnackbar';

import { useIntl } from 'react-intl';
import {
  useLoadFavouriteStations,
  useHandleSetRoutePoint,
  useFilteredFavouriteStations,
  useShowFavouriteStationsActions,
  useDeleteFavouriteStation,
  useAddFavouriteStation
} from '../../../hooks';
import {
  useBoolState,
  useShowMenu
} from 'common/hooks';
import {
  useFilterContext,
  useSelectedFavouriteStationContext
} from '../../../context';
import {
  useIsAddingFavouritStationsLoading,
  useIsDeletingFavouritStationsLoading
} from 'entities/stations';
import { useStyles } from './styles';

import { getStationIconSettings } from 'common/utils';

export const FavouriteStations = () => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const deleteFavouriteStation = useDeleteFavouriteStation();
  const { searchString } = useFilterContext();
  const filteredFavouriteStations = useFilteredFavouriteStations();
  const showFavouriteStationsActions = useShowFavouriteStationsActions();
  const { anchorEl, onShowMenu, onCloseMenu } = useShowMenu();
  const loadFavouriteStations = useLoadFavouriteStations();
  const isAddingFavouritStationsLoading = useIsAddingFavouritStationsLoading();
  const isDeletingFavouritStationsLoading = useIsDeletingFavouritStationsLoading();
  const [ showSearch, toogleShowSearh,, hideSearch ] = useBoolState(false);
  const [ showDeleteModal, toogleShowDeleteModal,, hideDeleteModal ] = useBoolState(false);
  const {
    selectedFavouriteStation,
    setSelectedFavouriteStation
  } = useSelectedFavouriteStationContext();
  const handleSetRoutePoint = useHandleSetRoutePoint();
  const addFavouriteStation = useAddFavouriteStation();

  return (
    <>
      <ListCollapse
        title={formatMessage({ id: 'favouriteStations' })}
        action={
          isAddingFavouritStationsLoading
          ? <CircularProgress size={22} classes={{ root: classes.circularProgress }} />
          : !searchString.length && showFavouriteStationsActions
            ? <IconButton kind={'add'} onClick={toogleShowSearh} />
            : null
        }
      >
        {
          showSearch && !searchString.length && (
            <Search
              renderOption={({ value }: any) => (
                <StationAutoselectOption
                  stationCode={value}
                  showIconFavouriteStation={false}
                />
              )}
              loadOptions={loadFavouriteStations}
              onChange={async (_: any, { value }: any) => {
                hideSearch();
                addFavouriteStation(value);
              }}
              placeholder={formatMessage({ id: 'findStation' })}
            />
          )
        }
        {
          filteredFavouriteStations.map((favouriteStation) => {
            const {
              stationCode,
              brandName,
              category: {
                code: categoryCode
              },
              roadsideServices,
              address
            } = favouriteStation;
            const roadsideServiceCodes = roadsideServices.map(({ code }) => code);
            const { icon, iconColor = ''} = getStationIconSettings(categoryCode, roadsideServiceCodes);
            return (
              <ListItemIcon
                key={stationCode}
                title={`${stationCode} • ${brandName ? brandName : ''}`}
                subtitle={address}
                icon={icon}
                iconColor={iconColor}
                action={
                  isDeletingFavouritStationsLoading && selectedFavouriteStation?.stationCode === stationCode
                  ? <CircularProgress
                      size={22}
                      classes={{ root: classes.circularProgress }}
                    />
                  : <IconButton
                      kind={'moreVert'}
                      onClick={(event) => {
                        setSelectedFavouriteStation(favouriteStation);
                        onShowMenu(event);
                      }}
                    />
                }
              />
            )
          })
        }
        <EmptyItemsMessage />
        <EmptyFilteredItemsMessage />
      </ListCollapse>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={onCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => {
            handleSetRoutePoint();
          }}
        >
          {formatMessage({ id: 'buildingRoute.buildRoute' })}
        </MenuItem>
        {
          showFavouriteStationsActions && (
            <MenuItem
              onClick={() => {
                toogleShowDeleteModal();
                onCloseMenu();
              }}
            >
              {formatMessage({ id: 'deleteFromFavorites' })}
            </MenuItem>
          )
        }
      </Menu>
      <FavouriteStationsDeleteModal
        open={showDeleteModal}
        onOk={async () => {
          if (selectedFavouriteStation) {
            deleteFavouriteStation(selectedFavouriteStation.stationCode);
            hideDeleteModal();
          }
        }}
        onCancel={hideDeleteModal}
      />
      <FavouriteStationsAddSnackbar />
    </>
  );
};
